import type { HomeworkAssignment } from "@classroom/domain";
import { i18n } from "../i18n";

type Category = HomeworkAssignment["category"] | "uncategorized";

export function isExamCategory(category?: Category) {
  return category === "assessment" || category === "dictation";
}

// The same stored statuses describe submissions or exam participation by category.
export function assignmentRecordLabels(category?: Category) {
  const t = i18n.getFixedT(null, "assignmentRecords");
  const kind = isExamCategory(category) ? "exam" : "homework";
  const statuses = {
    complete: t(`${kind}.statuses.complete`),
    missing: t(`${kind}.statuses.missing`),
    late: t(`${kind}.statuses.late`),
    excused: t(`${kind}.statuses.excused`),
  };
  return {
    statuses,
    counts: { ...statuses, missing: kind === "homework" ? t("homework.pendingMissing") : statuses.missing },
    date: t(
      category === "assessment" ? "assessmentDate" : category === "dictation" ? "dictationDate" : "homework.date",
    ),
    record: t(`${kind}.record`),
    state: t(`${kind}.state`),
    noMissing: t(`${kind}.noMissing`),
    saved: t(`${kind}.saved`),
    missingList: (students: string) => t(`${kind}.missingList`, { students }),
    studentState: (number: number | string, name: string) => t(`${kind}.studentState`, { number, name }),
  };
}
